<template>
  <div class="card mb-3">
    <div class="card-body">
      <h3>{{ tabTitle }}</h3>
      <SearchEvent
        :search="search"
        @update:search="$emit('update:search', $event)"
      />
      <br />
      <ul class="nav nav-tabs mb-2">
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: filterState === 2 }"
            href="#"
            @click.prevent="filterState = 2"
            >Activos</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            :class="{ active: filterState === 3 }"
            href="#"
            @click.prevent="filterState = 3"
            >Concluidos</a
          >
        </li>
      </ul>
      <div v-if="filteredEvents.length === 0" class="alert text-center mt-3">
        <EmptyState
          title="No se encontraron eventos."
          :size="200"
          fontSize="fs-6"
        />
      </div>
      <div v-else class="mt-3">
        <div class="list-group event-list-scroll">
          <button
            v-for="event in filteredEvents"
            :key="event.id"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            :class="{ active: selectedEvent && selectedEvent.id === event.id }"
            @click="$emit('select-event', event)"
          >
            <div>
              <div class="fw-bold">{{ event.title }}</div>
              <div class="text-muted small">
                <template v-if="isSameDay(event.init_date, event.end_date)">
                  {{ formatDate(event.init_date) }}
                </template>
                <template v-else>
                  {{ formatDate(event.init_date) }} -
                  {{ formatDate(event.end_date) }}
                </template>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SearchEvent from "./searchEvent.vue";
import { computed } from "vue";
import EmptyState from "@/components/emptyState.vue";

const props = defineProps({
  events: {
    type: Array,
    required: true,
  },
  search: {
    type: String,
    default: "",
  },
  selectedEvent: {
    type: Object,
    default: null,
  },
});
function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

function isSameDay(dateA, dateB) {
  const a = new Date(dateA);
  const b = new Date(dateB);
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

import { ref } from "vue";

const filterState = ref(2); // 2: Activos, 3: Concluidos

const tabTitle = computed(() => {
  if (filterState.value === 2) return "Eventos Activos";
  if (filterState.value === 3) return "Eventos Concluidos";
  return "Eventos";
});

const filteredEvents = computed(() => {
  const term = props.search.toLowerCase();
  let filtered = props.events.filter((e) => e.state === filterState.value);
  if (!term) return filtered;
  return filtered.filter(
    (e) => e.title && e.title.toLowerCase().includes(term)
  );
});
</script>

<style scoped>
.event-list-scroll {
  max-height: 400px;
  overflow-y: auto;
  border-radius: 0.5rem;
}
</style>
